'use strict';

module.exports = {
  eventDataKeys: ['binNumber']
};